import React from "react";
import UncheckBox from "../../assets/images/UncheckBox.svg";
import CheckBox from "../../assets/images/CheckBox.svg";

interface ConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  fieldTextStyle: React.CSSProperties;
  errors: Record<string, string>;
  touched: Record<string, boolean>;
  setAndValidate: (field: string, value: string) => void;
}

const ConsentCheckbox: React.FC<ConsentCheckboxProps> = ({
  checked,
  onChange,
  fieldTextStyle,
  errors,
  touched,
  setAndValidate,
}) => {
  const hasError = Boolean(errors.consent && touched.consent);

  return (
    <div className="mt-6 md:mt-8 flex flex-col items-center">
      <label className="flex items-center gap-3 text-sm cursor-pointer select-none">
        <button
          type="button"
          aria-pressed={checked}
          aria-label="Consent for contact"
          aria-describedby={hasError ? "consent-error" : undefined}
          onClick={() => {
            const next = !checked;
            setAndValidate("consent", next ? "true" : "");
            onChange(next);
          }}
          className="consent-checkbox-glow h-5 w-5 p-0 m-0 inline-flex items-center justify-center bg-transparent rounded transition-shadow duration-200 focus:outline-none focus-visible:ring-0"
          style={{
            boxShadow: checked
              ? "0 0 12px rgba(41, 114, 215, 0.6), 0 0 24px rgba(41, 114, 215, 0.3)"
              : undefined,
          }}
        >
          <img
            src={checked ? CheckBox : UncheckBox}
            alt={checked ? "Checked" : "Unchecked"}
            className="h-4 w-4 pointer-events-none"
          />
        </button>
        <span
          className="text-[16px] md:text-[16px]"
          style={{
            WebkitBackgroundClip: "text",
            color: checked ? "#ffffff" : "#818181",
            fontFamily: "Inter, sans-serif",
            fontWeight: 400,
            lineHeight: "140%",
            letterSpacing: 0,
          }}
        >
          I give my permission for Armory Defense to contact me
        </span>
      </label>
      {hasError && (
        <p
          id="consent-error"
          role="alert"
          className="text-white mt-1"
          style={{
            ...fieldTextStyle,
            fontSize: 14,
            lineHeight: "140%",
            textShadow:
              "0px 0px 11.96px rgba(255,0,0,0.5), 0px 0px 23.92px #FF0000",
          }}
        >
          * {errors.consent}
        </p>
      )}
    </div>
  );
};

export default ConsentCheckbox;
